angular.module('components.media.VideoController', [
  'global',
  'components.media.VideoService'
])

/**
 * The VideoController manages scope logic and user
 * interaction.
 *
 * @class VideoController
 * @constructor
 * @module components.media.VideoController
 */
.controller('VideoController', [
  '$scope',
  '$sce',
  '$window',
  function ($scope, $sce, $window) {
    'use strict';

    $scope.formattedModel = {};

    function sppMessage(event) {
      var data = JSON.parse(event.data);

      if (data.topicData.interactionSpecifier === 'mediaReady') {
        $window
          .frames[0]
          .postMessage('{"type":"command","method":"play","playerId":"SmartPearsonPlayer"}', '*');
      }
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      $scope.formattedModel = _.cloneDeep($scope.model);
      $scope.formattedModel.uri = $sce.trustAsResourceUrl($scope.formattedModel.uri);

      if ($scope.formattedModel.autoplay) {
        $window.addEventListener('message', sppMessage, false);
      }
    }

    initialize();
  }
]);
